'use strict';

const Mn = require('backbone.marionette');
const ProjectPermission = require('common/domain/entity/project-permission');
const ProjectEditTemplate = require('balus/ui/template/body/project-role/content/permission/project-edit.hbs');
const Template = require('balus/ui/template/body/project-role/content/index.hbs');

const ProjectEditView = Mn.View.extend({
    template: ProjectEditTemplate
});

module.exports = Mn.View.extend({
    regions: {
        projectEdit: '.project-edit',
    },
    template: Template,

    onRender: function() {
        const getPermission = klass => {
            return this.model.getPermissions().find(
                p => p instanceof klass);
        };

        this.showChildView('projectEdit', new ProjectEditView({
            model: getPermission(ProjectPermission.ProjectEditPermission)
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project-role/content/index.js